var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal-vue"},[_c('div',{staticClass:"_overlay",on:{"click":_vm.closeModal}}),_c('div',{staticClass:"_modal",style:(_vm.style)},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }